(function() {
    'use strict';

    angular.module('l4b')
        .component('requiredDocumentationTable', {
            templateUrl: 'html/shared/requiredDocumentationTable/requiredDocumentationTable.html',
 			bindings: {
				showExamples: '<',
                metadata: '<'
			},
			controller: RequiredDocumentationTableController,
			controllerAs: 'vm'
        });

        
   RequiredDocumentationTableController.$inject = ['Constants', 'DTOFactory', 'GuidedProofService'];

    function RequiredDocumentationTableController(Constants, DTOFactory, GuidedProofService) {
        var vm = this;

        angular.extend(vm, {
            showDisclaimer: showDisclaimer,
            isCAWithProgram: false,
        });
		
        var currentProof = GuidedProofService.GetCurrentProofData();
        vm.application = DTOFactory.Application();

        var isProgramProof = currentProof.code == Constants.Requirement.ProgramProof.Code;

        vm.isCAWithProgram = vm.application != null && isProgramProof &&  vm.application.Address.State === Constants.State.California;

		function showDisclaimer(metadata) {
            if(metadata)
            {
              return metadata.some(m => m.hasDocumentTypeWithDisclaimer);
            }
            return false;
		}


    }
})();
